import React, { useState } from "react";
import "./switch.scss";

interface Props {
  isChecked: any;
  setIsChecked: any;
  isVesting?: boolean;
  className?: any;
}
export const FToggle = ({
  isChecked,
  setIsChecked,
  isVesting,
  className,
}: Props) => {
  return (
    <div>
      <label className="switch">
        {/* <input
          type="checkbox"
          onChange={() => {
            setIsChecked(!isChecked);
          }}
          {...isChecked}
        />
        <span
          className={`slider round ${className ? className : ""} ${
            isVesting && "vesting-slider"
          }`}
        ></span> */}
        <input
          type="checkbox"
          onChange={() => {
            setIsChecked(!isChecked);
          }}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};
